<template>
  <div class="orders">
    <v-layout v-bind="layout">
      <v-flex md12 lg8>
        <template v-for="(order, index) in orders">
          <card :order="order" :index="index"></card>
        </template>
      </v-flex>
      <v-flex sm4 hidden-md-and-down>
        <cart v-if="orders" type="items"></cart>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import api from '@/api/gungho'
  import Cart from '../cart'
  import Card from './card'

  export default {
    metaInfo: {
      title: 'Orders'
    },

    data () {
      return {
        orders: false
      }
    },

    components: {
      cart: Cart,
      card: Card
    },

    computed: {
      layout () {
        const layout = {}
        if (this.$vuetify.breakpoint.smAndDown) layout.column = true
        return layout
      }
    },

    beforeMount () {
      api.orders().then((data) => {
        this.orders = data.orders
      })
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?54778481